var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8666 11.2667C10.3533 10.8733 9.86659 10.4667 9.86659 9.83333C9.86659 9.10667 10.5399 8.6 11.6666 8.6C12.8533 8.6 13.2933 9.16667 13.3333 10H14.8066C14.7599 8.85333 14.0599 7.8 12.6666 7.46V6H10.6666V7.44C9.37326 7.72 8.33326 8.56 8.33326 9.84667C8.33326 11.3867 9.60659 12.1533 11.4666 12.6C13.1333 13 13.4666 13.5867 13.4666 14.2067C13.4666 14.6667 13.1399 15.4 11.6666 15.4C10.2933 15.4 9.75326 14.7867 9.67992 14H8.21326C8.29326 15.46 9.38659 16.28 10.6666 16.5533V18H12.6666V16.5667C13.9666 16.32 14.9999 15.5667 14.9999 14.2C14.9999 12.3067 13.3799 11.66 11.8666 11.2667Z",
    fill: "#8A939B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdLogo);
export default __webpack_public_path__ + "static/media/USDLogo.8b78871ade2afe6d3be392cf8ed746ff.svg";
export { ForwardRef as ReactComponent };